import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export const constantRoutes = [{
	path: '/',
	component: () => import('@/views/index/index'),
	hidden: true
}, {
	path: '/index',
	component: () => import('@/views/index/index'),
	hidden: true
}, {
	path: '/quan_sz',
	component: () => import('@/views/index/quan_sz'),
	hidden: true
},{
	path: '/detail_fav',
	component: () => import('@/views/index/detail_fav'),
	hidden: true
},  { //全景思政
	path: '/panorama',
	component: () => import('@/views/index/panorama'),
	hidden: true
},{
    path: '/new_clazz',
    component: () => import('@/views/index/new_clazz'),
    hidden: true
  },{
    path: '/class_detail',
    component: () => import('@/views/index/class_detail'),
    hidden: true
  },{ //全景思政详情页
	path: '/panorama_detail',
	component: () => import('@/views/index/panorama_detail'),
	hidden: true
}, { //vr仿真
	path: '/vr',
	component: () => import('@/views/index/vr'),
	hidden: true
}, { //站内信
	path: '/simessage',
	component: () => import('@/views/index/simessage'),
	hidden: true
},{ //评价中心
	path: '/pingjia',
	component: () => import('@/views/study_res/pingjia'),
	hidden: true
}, { //提交评价
	path: '/start_pingjia',
	component: () => import('@/views/study_res/start_pingjia'),
	hidden: true
}, { //学生评价中心
	path: '/stupingjia',
	component: () => import('@/views/homework/student/stupingjia'),
	hidden: true
}, { //学生提交评价
	path: '/stustart_pingjia',
	component: () => import('@/views/homework/student/stustart_pingjia'),
	hidden: true
},{ //vr仿真详情
	path: '/vr_detail',
	component: () => import('@/views/index/vr_detail'),
	meta:{
		title:'VR思政详情'
	},
	hidden: true
}, { //教学资源
	path: '/Teachingresources',
	component: () => import('@/views/Teachingresources/Teachingresources'),
	hidden: true
}, { //课程列表
	path: '/Teachingresources_details',
	component: () => import('@/views/Teachingresources/Teachingresources_details'),
	hidden: true
}, { // 个人信息
	path: '/table_lb',
	component: () => import('@/views/index/table_lb'),
	hidden: true
}, { // 课程中心
	path: '/table_lb_center',
	component: () => import('@/views/index/table_lb_center'),
	hidden: true
}, { // 个人信息
	path: '/statistics',
	component: () => import('@/views/index/statistics'),
	hidden: true
}, { // 思政学习
	path: '/study_tasks',
	component: () => import('@/views/index/study_tasks'),
	hidden: true
}, { // 作业中心
	path: '/work_center',
	component: () => import('@/views/index/work_center'),
	hidden: true
}, { // 实践中心
	path: '/practice',
	component: () => import('@/views/index/practice'),
	hidden: true
}, { // 详情
	path: '/detail',
	component: () => import('@/views/index/detail'),
	children: [{
			path: 'dir',
			component: () => import('@/views/study_res/directory'),
		},
	],
	hidden: true
},{
  path: '/dir_detail',
  component: () => import('@/views/study_res/directory_detail'),
  hidden: true
  },{ // 思政课程详情
	path: '/si_xiang',
	component: () => import('@/views/study_res/si_xiang'),
	hidden: true
},{ // 获取素材内容
	path: '/si_sucai',
	component: () => import('@/views/index/si_sucai'),
	hidden: true
}, {
  path: '/detail_fang',
  component: () => import('@/views/index/detail_fang'),
  hidden: true
  },{ // 获取素材内容
	path: '/news_create',
	component: () => import('@/views/index/news_create'),
	hidden: true
}, { // 获取素材xiang
	path: '/si_sucai_fav',
	component: () => import('@/views/index/si_sucai_fav'),
	hidden: true
}, { // 视频
	path: '/player',
	component: () => import('@/views/index/player'),
	hidden: true
}, { // 教师获取学生详情
	path: '/practice_details',
	component: () => import('@/views/index/practice_details'),
	hidden: true
}]

const createRouter = () => new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
})

const router = createRouter()
// router.beforeEach((to, from, next) => { //利用beforeEach来完成标题的修改
// 	window.document.title = to.matched[0].meta.title
// 	next()
// })
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-3579414657
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}


const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js